<template>
    <div>
        <b-card>
            <MyToolbar>
                <MyToolbarItem>
                    <b-input-group>
                        <b-input-group-prepend>
                            <label for="input-start-dt" class="mt-2">Дата:</label>
                        </b-input-group-prepend>
                        <b-input id="input-start-dt" v-model="searchStartDt" @change="buttonSearchClicked"
                                 :disabled="sortMode!==0"
                                 style="margin-left:10px;width:140px" size="sm" type="date"
                        />
                    </b-input-group>
                </MyToolbarItem>
                <MyToolbarItem>
                    <b-button size="sm" variant="secondary" @click="buttonSearchClicked">Поиск</b-button>
                    <b-button size="sm" :variant="sortMode===0 ? 'secondary' : 'primary'" title="Расширенный поиск"
                              class="button-icon-only-normal ml-2"
                              @click="buttonAdvSearchShowClicked"
                    >
                        <i class="fas fa-cog"/>
                    </b-button>
                </MyToolbarItem>
            </MyToolbar>

            <b-alert :show="err" :variant="errVariant" class="mb-4">{{errText}}</b-alert>

            <div v-show="userSessionList.length===0" class="text-center">
                Нет данных
            </div>
            <div v-show="userSessionList.length>0">
                <b-table outlined hover head-variant="light" :fields="userSessionListFields" :items="userSessionList"
                         responsive="responsive" :no-local-sorting="true" sort-by="SessionStart" sort-desc
                         @sort-changed="sortChanged"
                >
                    <template #cell(Active_)="data">
                        <b-badge :variant="getActiveVariantName(data.item.Active)">{{data.item.Active_}}</b-badge>
                        <b-button v-show="data.item.Active===1" variant="outline-secondary" size="sm"
                                  class="button-icon-only-small ml-2"
                                  title="Сбросить сессию" @click="buttonResetUserSessionClicked(data.item)"
                        >
                            <i class="fa fa-times"/>
                        </b-button>
                    </template>
                </b-table>
                <b-row>
                    <b-col sm="6">
                        <b-pagination first-number last-number
                                      v-model="recordCurrentPageNumber" @input="loadUserSessionList"
                                      :total-rows="recordTotalNumber" :per-page="recordCountPerPage"
                        />
                    </b-col>
                    <b-col sm="6">
                        <div class="custom-items-per-page-div">
                            <label>Показать записей:</label>
                            <b-form-select id="input-records-per-page" size="sm" style="margin-left: 10px;width:65px"
                                           :options="recordCountPerPageArray" v-model="recordCountPerPage"
                                           @change="loadUserSessionList"
                            />
                        </div>
                    </b-col>
                </b-row>
            </div>
        </b-card>
        <b-modal ref="modal-search" hide-footer centered title="Расширенный поиск">
            <b-alert :show="errModal" :variant="errVariantModal" class="mb-4">{{errTextModal}}</b-alert>
            <b-row>
                <b-col sm="6">
                    <b-form-group label="Дата начала" label-for="input-AdvSearch-start-dt">
                        <b-input id="input-AdvSearch-start-dt" v-model="searchStartDt" type="date"/>
                    </b-form-group>
                </b-col>
                <b-col sm="6">
                    <b-form-group label="Дата окончания" label-for="input-AdvSearch-end-dt">
                        <b-input id="input-AdvSearch-end-dt" v-model="searchEndDt" type="date"/>
                    </b-form-group>
                </b-col>
                <b-col sm="12">
                    <b-form-group label="Пользователь">
                        <v-select2 label="UserName" :filterable="false"
                                   :reduce="user => user.UID"
                                   :options="searchRefUsers" v-model="searchUserUid"
                                   @search="fetchSearchRefUsers"
                        >
                            <template slot="no-options">
                                Введите для поиска пользователя..
                            </template>
                        </v-select2>
                    </b-form-group>
                </b-col>
                <b-col sm="12">
                    <b-form-group label="IP адрес" label-for="input-AdvSearch-remote-host">
                        <b-input id="input-AdvSearch-remote-host" v-model="searchRemoteHost"/>
                    </b-form-group>
                </b-col>
            </b-row>
            <div>
                <b-button variant="outline-danger" @click="buttonAdvSearchCancelClicked">Сбросить</b-button>
                <b-button variant="secondary" class="ml-2 float-right" @click="buttonAdvSearchCloseClicked">Закрыть
                </b-button>
                <b-button variant="primary" class="float-right" @click="buttonAdvSearchOkClicked">Поиск</b-button>
            </div>
        </b-modal>
    </div>
</template>

<script>
    import {SET_BREADCRUMB} from "@/core/services/store/breadcrumbs.module";
    import MyToolbar from "@/view/components/MyToolbar";
    import MyToolbarItem from "@/view/components/MyToolbarItem";
    import axios from "axios";
    import {debounce} from '../../../assets/js/components/debounce'

    export default {
        name: "UserSessions",
        components: {MyToolbar, MyToolbarItem},
        data() {
            return {
                userData: this.$store.getters.getUserData,
                recordCountPerPageArray: this.$store.getters.getRecordCountPerPageArray || [],
                recordCountPerPage: this.$store.getters.getRecordCountPerPage || 20,
                recordCurrentPageNumber: 1,
                recordTotalNumber: 0,

                loadProcessing: 0,

                err: false,
                errText: "",
                errVariant: "danger",

                errModal: false,
                errTextModal: "",
                errVariantModal: "danger",

                searchStartDt: new Date().toISOString().substr(0, 10),
                searchEndDt: new Date().toISOString().substr(0, 10),
                searchUserUid: "",
                searchRemoteHost: "",

                sortMode: 0,    //0-simple, 1-advanced
                sortBy: "SessionStart",
                sortDesc: true,

                searchRefUsers: [],

                userSessionList: [],
                userSessionListFields: [
                    {key: "RowNumber", label: "№", thStyle: "width: 80px",},
                    {key: "UserName", label: "Пользователь", sortable: true, thStyle: "min-width: 150px"},
                    {key: "Active_", label: "Статус сессии", thStyle: "width: 200px"},
                    {key: "SessionStart", label: "Начало сессии", sortable: true, thStyle: "width: 150px"},
                    {key: "SessionEnd", label: "Конец сессии", sortable: true, thStyle: "width: 150px"},
                    {key: "LastActivity", label: "Последняя активность", sortable: true, thStyle: "width: 150px"},
                    {key: "RemoteHost", label: "IP адрес"},
                    {key: "ClientType_", label: "Вид клиента"},
                ],

            }
        },
        mounted() {
            this.$store.dispatch(SET_BREADCRUMB, [
                {title: "Сервис", route: "user-sessions"},
                {title: "Сессии пользователей"}
            ]);
            this.loadUserSessionList()
            this.loadSearchRefUsers(null, "", this)
        },
        methods: {
            errTextHide() {
                this.err = false
                this.errText = ""
            },
            errTextShow(msg, variant = "danger", withScroll = true) {
                if (withScroll)
                    window.scrollTo(0, 0)
                this.errText = msg
                this.errVariant = variant
                this.err = true
            },
            errTextHideModal() {
                this.errModal = false
                this.errTextModal = ""
            },
            errTextShowModal(msg, variant = "danger", withScroll = true) {
                if (withScroll)
                    window.scrollTo(0, 0)
                this.errTextModal = msg
                this.errVariantModal = variant
                this.errModal = true
            },
            sortChanged(e) {
                this.sortBy = e.sortBy
                this.sortDesc = e.sortDesc
                this.loadUserSessionList()
            },
            buttonSearchClicked() {
                if (this.sortMode === 0)
                    this.searchEndDt = this.searchStartDt
                this.recordCurrentPageNumber = 1
                this.loadUserSessionList()
            },
            buttonAdvSearchShowClicked() {
                this.errTextHideModal()
                this.$refs['modal-search'].show()
            },
            buttonAdvSearchOkClicked() {
                this.errTextHideModal()
                if (this.searchStartDt === "") {
                    this.errTextShowModal("Введите дату начала.", "info")
                    return
                }
                if (this.searchEndDt === "") {
                    this.errTextShowModal("Введите дату окончания.", "info")
                    return
                }
                if (this.searchStartDt > this.searchEndDt) {
                    this.errTextShowModal("Дата начала не может быть позднее даты окончания.", "info")
                    return
                }

                this.sortMode = 1
                this.$refs['modal-search'].hide()
                this.recordCurrentPageNumber = 1
                this.loadUserSessionList()
            },
            buttonAdvSearchCloseClicked() {
                this.$refs['modal-search'].hide()
            },
            buttonAdvSearchCancelClicked() {
                this.sortMode = 0
                this.searchStartDt = new Date().toISOString().substr(0, 10)
                this.searchUserUid = ""
                this.searchRemoteHost = ""
                this.recordCurrentPageNumber = 1
                this.$refs['modal-search'].hide()
                this.loadUserSessionList()
            },
            fetchSearchRefUsers(search, loading) {
                if (search.length) {
                    loading(true)
                    this.loadSearchRefUsers(loading, search, this)
                }
            },
            loadSearchRefUsers: debounce((loading, search, vm) => {
                vm.searchRefUsers = []

                axios.post("/ws/ws.svc/GetSerUsersArray", {
                        'Session_UID': vm.userData.Session_UID,
                        'F_QuickFilter': search,
                    },
                    {headers: {"Content-Type": "application/json"}}
                )
                    .then(resp => {
                        if (!vm.isUndefined(resp.data.success) && !vm.isUndefined(resp.data.response) &&
                            !vm.isUndefined(resp.data.data)) {
                            if (resp.data.success) {

                                if (resp.data.data.toString().length > 0) {
                                    vm.searchRefUsers = JSON.parse(resp.data.data)

                                }
                            } else {
                                vm.errTextShowModal(resp.data.response.toString())
                            }
                        } else {
                            vm.errTextShowModal("Неверный формат ответа.")
                        }
                        if (loading) loading(false);
                    })
                    .catch(err => {
                        if (loading) loading(false);
                    })
            }, 350),
            loadUserSessionList() {
                this.errTextHide()

                if (this.searchStartDt === "") {
                    this.errTextShow("Введите дату начала.", "info", true)
                    return
                }
                if (this.sortMode === 0) {
                    this.searchEndDt = this.searchStartDt
                }
                if (this.searchEndDt === "") {
                    this.errTextShow("Введите дату окончания.", "info", true)
                    return
                }
                if (this.searchStartDt > this.searchEndDt) {
                    this.errTextShow("Дата начала не может быть позднее даты окончания.", "info", true)
                    return
                }

                this.loadProcessing++
                axios.post("/ws/ws.svc/GetSerUsersSessions", {
                        'Session_UID': this.userData.Session_UID,
                        'Page': this.recordCurrentPageNumber,
                        'RecordsPerPage': this.recordCountPerPage,
                        'SortField': this.sortBy,
                        'SortMode': (this.sortDesc ? 1 : 0),
                        'F_DT1': this.getFormatDate(this.searchStartDt, "DD.MM.yyyy"),
                        'F_DT2': this.getFormatDate(this.searchEndDt, "DD.MM.yyyy"),
                        'F_User_UID': this.searchUserUid,
                        'F_RemoteHost': this.searchRemoteHost,
                    },
                    {headers: {"Content-Type": "application/json"}}
                )
                    .then(resp => {
                        if (this.isUndefined(resp.data.success) || this.isUndefined(resp.data.response)
                            || this.isUndefined(resp.data.data) || this.isUndefined(resp.data.meta)) {
                            this.errTextShow("Неверный формат ответа.", "danger", true)
                        } else {
                            if (resp.data.success) {
                                if (resp.data.data.toString().length > 0) {
                                    this.userSessionList = JSON.parse(resp.data.data)
                                    if (!this.isUndefined(resp.data.meta.TotalRecordsAmount)) {
                                        this.recordTotalNumber = resp.data.meta.TotalRecordsAmount
                                    } else {
                                        this.errTextShow("Ошибка при получении общего кол-ва записей.", "danger", true)
                                    }
                                } else {
                                    this.recordTotalNumber = 0
                                    this.userSessionList = []

                                }
                            } else {
                                this.errTextShow(resp.data.response.toString(), "danger", true)
                            }
                        }

                        this.loadProcessing--
                    })
                    .catch(err => {
                        this.errTextShow("Ошибка при получении данных (" + err.message + ")", "danger", true)
                        this.loadProcessing--
                    })
            },
            buttonResetUserSessionClicked(item) {
                this.errTextHideModal()

                this.loadProcessing++
                axios.post("/ws/ws.svc/SerResetUserSession", {
                        'Session_UID': this.userData.Session_UID,
                        'F_Session_UID': item.Session_UID,
                    },
                    {headers: {"Content-Type": "application/json"}}
                )
                    .then(resp => {
                        if (!this.isUndefined(resp.data.success) && !this.isUndefined(resp.data.response)) {
                            if (resp.data.success) {
                                this.loadUserSessionList()
                            } else {
                                this.errTextShow(resp.data.response.toString(), "danger", true)
                            }
                        } else {
                            this.errTextShow("Неверный формат ответа.", "danger", true)
                        }
                        this.loadProcessing--
                    })
                    .catch(err => {
                        this.errTextShow("Ошибка при сохранении данных (" + err.message + ")", "danger", true)
                        this.loadProcessing--
                    })
            },
            getActiveVariantName: function (active) {
                if (active === 0) return "secondary"
                else if (active === 1) return "success"
                else if (active === 2) return "danger"
                else return ""
            },
        },
        watch: {
            loadProcessing: function () {
                this.$store.commit('set', ["showSpinner", this.loadProcessing > 0])
            },
        }

    }
</script>

<style scoped>

</style>